import { Table, Paper, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { FC } from "react";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";

interface TermosAceitePropostaProps {
    data: any;
}

const TermosAceiteProposta: FC<TermosAceitePropostaProps> = ({
    data,
}) => {

    function handleMaxParcelas(dadosParcela: any, projeto: any) {
        const parcelasCartao: any = []
        const parcelas = dadosParcela || []

        parcelas.forEach((parcela: any) => {
            if (projeto.valor_servico_pis_cofins !== 0 || projeto.valor_servico !== 0) {
                if (parcela?.servicos_pedido?.length > 0 &&
                    parcela.servicos_pedido.find((sp: any) => sp.servico_pedido !== 'sem_servico') &&
                    parcelasCartao.find((p: any) => p === parcela.parcelas) === undefined) {
                    parcelasCartao.push(parcela.parcelas)
                }
            } else {
                if (parcela?.servicos_pedido?.length > 0 &&
                    parcela.servicos_pedido.find((sp: any) => sp.servico_pedido === 'sem_servico') &&
                    parcelasCartao.find((p: any) => p === parcela.parcelas) === undefined) {
                    parcelasCartao.push(parcela.parcelas)
                }
            }
        })

        return parcelasCartao?.[parcelasCartao.length - 1] || 12;
    }

    return <>

        <div className="title">Termo de aceite da proposta</div>

        <div style={{ marginTop: "12pt" }} />

        <div className="title-proposta-comercial">Proposta comercial nº {data.projeto?.codigo_venda}</div>

        <Table component={Paper} size="small" className="table table-termos-aceite">
            <TableHead>
                <TableRow>
                    <TableCell colSpan={2} className="tableColEquipamentoHead bg-verde-escuro" style={{ textAlign: "center", height: "35pt" }}>{data.projeto?.cliente_proposta}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell className="tableColEquipamento" style={{ textAlign: "center", width: "50%" }}>
                        <span className="tableCellEquipamentos" style={{ fontSize: "11pt" }}>Valor da negociação: R$ {DecimalUtil.decimal(data.projeto?.valor_projeto)}</span>
                    </TableCell>
                    <TableCell className="tableCellEquipamentos" style={{ paddingTop: "12pt", paddingBottom: "12pt" }}>
                        <span className="tableCellEquipamentos" style={{ fontSize: "11pt" }}>
                            <div className="default-small-text"><span>Forma de pagamento:</span></div>
                            <div className="default-small-text"><span>[  ] Boleto (à vista)</span></div>
                            <div className="default-small-text"><span>[  ] Cartão de crédito em até {handleMaxParcelas(data.valorParcelasCartao, data.projeto)}x com juros</span></div>
                            <div className="default-small-text"><span>[  ] Financiamento bancário</span></div>
                        </span>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell colSpan={2} className="tableCellEquipamentos tableCellTermoAceiteFooter">
                        <span className="tableCellEquipamentos" style={{ fontSize: "11pt" }}>
                            <div className="default-small-text"><span>Produtos Intelbras e serviços:</span></div>
                            <div className="default-small-text" style={{ marginTop: "9pt" }}><span>[ ] Financiamento bancário</span></div>
                        </span>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>

        <div className="default-text-list" style={{ marginTop: "42pt", marginBottom: "8pt", textAlign: "center" }}><span>Manifesto a aceitação da proposta referida, nos valores, quantidades e condições de</span></div>

        <div className="default-text-list" style={{ marginTop: "12pt", marginBottom: "42pt", textAlign: "center" }}><span>pagamento previstas na Proposta Comercial em anexo.</span></div>

        <div className="title">Dados do cliente</div>

        <div style={{ marginTop: "20pt" }} />
        <div className="client-info">
            <div className="client-info-div"><span>Nome:</span></div>
            <div className="client-info-div"><span>Data:</span></div>
            <div className="client-info-div"><span>CPF:</span></div>
            <div >Assinatura:</div>
        </div>

        <div className="container-prazo-entrega" style={{ marginTop: "20pt" }}>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega texto-termo-aceite"><span>Considerando que o aceite firmado nesta presente proposta, seja de forma online na Plataforma Solar
                    ou de forma física, na via impressa, obrigará as partes às condições e obrigações nela estabelecidas
                    em uma relação contratual válida e irrevogável, as partes não poderão ceder ou transferir esta proposta
                    ou quaisquer benefícios, interesses, direitos ou obrigações decorrentes do mesmo, no todo ou em
                    parte, a quaisquer terceiros, sem o consentimento prévio e por escrito da outra parte.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega texto-termo-aceite"><span>A validade das condições desta proposta depende da disponibilidade de estoque e da confirmação de
                    pagamento ou da assinatura do respectivo <strong>contrato de financiamento com a instituição bancária.</strong></span></div>
            </div>
        </div>

    </>
}

export default TermosAceiteProposta;